import constants from 'constants';

const {
  START_REQUEST,
  END_REQUEST
} = constants;

export const startRequest = (request) => ({
  payload: {
    request,
  },
  type: START_REQUEST
});

export const endRequest = (request) => ({
  payload: {
    request
  },
  type: END_REQUEST
});



/** WEBPACK FOOTER **
 ** ./src/actions/requests.js
 **/